import { render, staticRenderFns } from "./multipleImgUpload.vue?vue&type=template&id=b18c53d0&"
import script from "./multipleImgUpload.vue?vue&type=script&lang=js&"
export * from "./multipleImgUpload.vue?vue&type=script&lang=js&"
import style0 from "./multipleImgUpload.vue?vue&type=style&index=0&id=b18c53d0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports